import { STAGGER_MS } from '@roomtreatment/design';

/**
 * A line that arrives word by word, each word rising out of a blur.
 *
 * After React Bits' BlurText (MIT + Commons Clause, used inside the product as
 * its licence allows), rebuilt as pure CSS: the words are the line's only
 * text, real in the server HTML (for crawlers, assistive tech and the first
 * paint's layout), each on the shared spring (`.rt-word-in`, globals.css), a
 * stagger step apart — the design language's "this caused that" interval, not
 * a number picked here. Reduced motion shows the line at rest.
 */
export default function BlurText({ text, startIndex = 0 }: {
  text: string;
  /** Stagger steps to wait before the first word (to follow an earlier line). */
  startIndex?: number;
}) {
  const words = text.split(' ');
  return words.map((word, i) => (
    <span key={i}>
      <span className="rt-word-in" style={stagger(startIndex + i)}>{word}</span>
      {i < words.length - 1 ? ' ' : null}
    </span>
  ));
}

/** The delay for the element `step` stagger steps into an entrance. */
export function stagger(step: number) {
  return { animationDelay: `${step * STAGGER_MS}ms` };
}
